import React from 'react';

import { CIAN_URL } from '../../constants';
import { IUserCardParams, UserCard } from './UserCard';
import { IUserDataItemSchema } from '../../repositories/journal/entities/user_data_item/UserDataItemSchema';

interface IUserCardForAuthorObject extends IUserDataItemSchema {
  avatarSize?: IUserCardParams['avatarSize'];
  fontSize?: IUserCardParams['fontSize'];
  onClick?(e: React.MouseEvent): void;
  isStrongName?: IUserCardParams['isStrongName'];
  afterName?: IUserCardParams['afterName'];
  afterAll?: IUserCardParams['afterAll'];
  withCianLogo?: IUserCardParams['withCianLogo'];
  hasEllipsisContent?: IUserCardParams['hasEllipsisContent'];
}

/**
 * Карточка пользователя для объекта пользователя authorObject
 */
export const UserCardForAuthorObject = ({
  avatar,
  fullName,
  companyName,
  userId,
  userTrust,
  specialistLink,
  avatarSize,
  fontSize,
  onClick,
  isStrongName,
  afterName,
  afterAll,
  withCianLogo,
  hasEllipsisContent,
}: IUserCardForAuthorObject) => {
  const url = specialistLink ? `${CIAN_URL}${specialistLink}` : undefined;

  const handleClick = (e: React.MouseEvent) => {
    if (!url) {
      return;
    }

    if (onClick) {
      return onClick(e);
    }

    e.preventDefault();
    window.open(url, '_blank');
  };

  return (
    <UserCard
      imageSrc={avatar || undefined}
      name={fullName || companyName || (userId ? `ID: ${userId}` : 'Аноним')}
      description={(fullName && companyName) || undefined}
      isTrusted={userTrust || undefined}
      url={url}
      avatarSize={avatarSize}
      fontSize={fontSize}
      isStrongName={isStrongName}
      withCianLogo={withCianLogo}
      hasEllipsisContent={hasEllipsisContent}
      afterName={afterName}
      afterAll={afterAll}
      onClick={handleClick}
    />
  );
};
